export enum ERROR_CODES {
    USER_NOT_REGISTERED = 'CTRLEVENTSV21169',
    USER_ALREADY_REGISTERED = 'CTRLSUBSCRIPTIONS232',
    USER_ALREADY_ACTIVATED = "CTRLUSRSACT125",
    FILE_TOO_LARGE = "file-too-large",
    FILE_INVALID_TYPE = "file-invalid-type",
    USER_INVALID_AUTHENTIFICATION = "CTRLUSRSAUTH149",
    USER_DOES_NOT_EXIST = "CTRLUSRSAUTH154"
}